import React from 'react';
import { observer } from 'mobx-react-lite';

import { BetBlock } from '../../components/web';
import { BetBlockWrapper, WinPopUp } from '../../components/common';
import { MobileMainTopWrapper } from '../../components/mobile/mobileMainTopWrapper';

export const MobileGameWrapper = observer(() => {
  // Todo ${gameScene ? 'hide' : ''} for parent class
  return (
    <div className='mobile-game-content'>
      <MobileMainTopWrapper />
      <div className='mobile-game-content-bottom'>
        <WinPopUp />
        <div className='mob-g-bot-content'>
          <BetBlockWrapper innerComp={BetBlock} />
        </div>
      </div>
    </div>
  );
});
